import React, { useEffect } from 'react';
import { useConversations } from '../hooks/useChat';
import { getSocket, initSocket } from '../socket/client';
import { Avatar } from '@mui/material';
import { useNotify } from '@/notifications/NotificationProvider';

type ChatType ={ 
  token: string, 
  selected: string, 
  onSelect: (convId: string)=>void, 
  setSelectedUser: (user: any) => void, 
  selectedUser: any 
}

export default function ChatList({ token,selected, onSelect, setSelectedUser, selectedUser}: ChatType) {
  const { conversations, loading, mutate } = useConversations();
  const {notify} = useNotify();

  useEffect(() => {
    const sock = initSocket(token);
    const handler = (msg : any) => {
        // console.log(selectedUser?._id , msg.userId)
        // if(selectedUser?._id == ){
        //     notify({title: msg.name, message: msg.text})
        // }
        mutate()
    };
    sock.on('message:new', handler);
    sock.on('presence:update', handler);
    return () => {
      sock.off('message:new', handler);
      sock.off('presence:update', handler);
    };
  }, [token, mutate]);

  if (loading) return <div>Loading chats…</div>;
  return (
    <div className="divide-y border rounded">
      {conversations.map((c:any) => (
        <button key={c._id} className={`w-full text-left p-3 hover:bg-gray-50 flex justify-between ${selected === c._id ? 'bg-blue-100' : ''}`} onClick={()=>{
            onSelect(c._id);
            setSelectedUser(c.counterpart);
        }}>
          <div className='flex gap-2'>
            <div>
                <Avatar src={c.counterpart?.avatar} />
            </div>
            <div>
                <div className="font-semibold">{c.counterpart?.firstName} {c.counterpart?.lastName}</div>
                <div className='text-sm text-gray-600'>{c.counterpart?.email}</div>
                <div className="text-sm text-gray-600 truncate">{c.lastMessage || 'Start chatting'}</div>
            </div>
          </div>
          {c.unread > 0 && <span className="text-xs bg-blue-600 text-white h-6 min-w-6 px-2 rounded-full flex items-center justify-center">{c.unread}</span>}
        </button>
      ))}
      {conversations.length === 0 && <div className="p-3 text-sm text-gray-500">No conversations yet.</div>}
    </div>
  );
}
